
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { Spell } from '@dndModels';

import DandDAPI from "@dndUtilities/system_api";

import NonFSIndex from "@dndComponents/NonFSIndex";
import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import SpellManager from "@dndViews/spell/SpellManager";
import ViewSpell from '@dndComponents/display/ViewSpell';
import SpellDetails from '@dndComponents/display/SpellDetails';
// import { Spell } from '@dndModels';
// import ToggleButtonBox from '@components/input/buttons/ToggleButtonBox';
// import DisplayObjects from '../../components/display/DisplayObjects';

const api = DandDAPI.getInstance();

export default function SpellIndex() {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  // const [use_extra_filter, setUseExtraFilter] = useState(true);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={open}
          width={800}
          onClose={() => { setOpen(false); }}>
          <SpellManager />
        </ModalOrDrawer>
      </>
    );
  }
  
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (reloading) {
    return <></>;
  } else {
    return (
      <>
        <NonFSIndex
          data_type="spell"
          // save_all
          // name_display={(obj) => {
          //   if (obj instanceof Spell) {
          //     return (
          //       <ViewSpell
          //         spell={obj}
          //         show_ritual
          //         hide_details
          //       />
          //     );
              
          //     // return <>{ obj.use_name } (<DisplayObjects type='source_book' ids={obj.source_book_ids} />)</>;
          //   }
          //   return <></>;
          // }}
          extra_by_add={api.user && api.user.admin ? () => {
            // debugger;
            return (
              <>
                &nbsp;
                <AddButton
                  label="Parse Add"
                  onClick={() => {
                    setNavigateTo(`/spell/parse_add`);
                  }}
                />
                &nbsp;
                <Button
                  variant="contained" color="primary" 
                  onClick={() => {
                    setOpen(true);
                  }}>
                  Spell Manager
                </Button>
                {/* &nbsp;
                <ToggleButtonBox
                  name="Use Extra Filter"
                  value={use_extra_filter}
                  onToggle={() => { {
                    setUseExtraFilter(!use_extra_filter);
                    setReloading(true);
                  }}}
                /> */}
              </>
            );
          } : undefined}
          extra={(obj) => {
            if (obj instanceof Spell) {
              const the_spell = obj;
              return (
                <Grid container spacing={0} direction="row">
                  <Grid size={6}>
                    <ViewSpell spell={the_spell}
                      show_level 
                      show_ritual
                      fontSize={20}
                      fontWeight={"bold"}
                    />
                  </Grid>
                  <Grid size={12}>
                    { the_spell.level_and_school }
                  </Grid>
                  <Grid size={12}>
                    <SpellDetails spell={the_spell} />
                  </Grid>
                </Grid>
              );
            }
            return <></>;
          }}
          quick_fields={["school","spell_level","spell_list"]}
        />
        { renderExtras() }
      </>
    );
  }
}